export enum ENV {
  'DEV' = 'dev',
  'QUAL' = 'qual',
  'PREPROD' = 'preprod',
  'PROD' = 'prod',
}
